<template>
  <div class="product-features-list">
    <read-more
      v-if="showMoreLink"
      text-more="ads.main.detail.read_more"
      text-less="ads.main.detail.read_less"
      :max-height="maxHeight"
      :scroll-less-element="`.${scrollLessElement}`"
    >
      <product-features-list-inner
        :features="features"
      />
    </read-more>
    <product-features-list-inner
      v-else
      :features="features"
    />
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import ReadMore from '../readMore/readMore.vue';
  import ProductFeaturesListInner from './productFeaturesListInner.vue';

  @Options({
    name: 'product-features-list',
    components: {
      ReadMore,
      ProductFeaturesListInner
    },
  })
  export default class ProductFeaturesList extends Vue {
    @Prop()
    scrollLessElement: string;

    @Prop()
    features: Array<{
      headline: string,
      values: Array<{
        name: string,
        value: string
      }>
    }>;

    @Prop({type: Number, default: 360})
    readonly maxHeight!: Number

    @Prop({default: true})
    showMoreLink: boolean;
  }
</script>
